module.exports = __webpack_public_path__ + "static/media/Alert.bf19988d.svg";